import { store } from '../../store'
import { http } from '../../main'

// initial state
const state = {}

// getters
const getters = {}

// actions

const actions = {
  get ({commit, dispatch}, payload) {
    let url = 'api/subscriptions'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('subscriptionsGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getBranchesCompanies ({ commit, dispatch }, payload) {
    let url = 'api/branches-company'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetBranchesCompanies', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  post ({ commit, dispatch }, payload) {
    let url = 'api/subscriptions'
    let params = {
      'company_id': payload.event.item.company_id,
      'plan_id': payload.event.item.plan_id,
      'expiration_date': payload.event.item.expiration_date
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.post(url, params, {})
      .then(
        response => {
          commit('onPost', {event: payload.event, response: response})
        },
        error => {
          commit('onPostError', {event: payload.event, error: error})
        }
      )
  },
  put ({ commit, dispatch }, payload) {
    let url = 'api/subscriptions/' + payload.event.item.id
    let params = {
      'expiration_date': payload.event.item.expiration_date,
      'plan_id': payload.event.item.plan_id
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.put(url, params, {})
      .then(
        response => {
          commit('onPut', {event: payload.event, response: response})
        },
        error => {
          commit('onPutError', {event: payload.event, error: error})
        }
      )
  },
  delete ({ commit, dispatch }, payload) {
    let url = 'api/subscriptions/' + payload.event.item.id
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.delete(url, {}, {})
      .then(
        response => {
          commit('onDelete', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

const mutations = {
  subscriptionsGet (state, payload) {
    payload.event.context.subscriptions = payload.response.data.data
  },
  onPost (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
    payload.event.context.refresh()
  },
  onPut (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
    payload.event.context.refresh()
  },
  // Removes the data of the deleted user from the users list
  onDelete (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.closeDelete()
    payload.event.context.refresh()
  },
  // Shows a error message
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }

    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    // payload.event.context.refresh()
  },
  // Shows a error message
  onPostError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    // payload.event.context.refresh()
    payload.event.context.loading = false
  },
  // Shows a error message
  onPutError (state, payload) {
    // payload.event.context.setMessage(payload.error.response.data.message)
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    // payload.event.context.refresh()
    payload.event.context.loading = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/subscriptions.js